module.exports = __webpack_public_path__ + "img/CCR-2.29f2d9f7.png";